<template>
  <form-group>
    <fade-in-out>
      <v-row
        v-if="!storeId"
      >
        <v-col cols="12">
          <div>
            <v-btn
              :loading="loading"
              :disabled="isDisabled"
              color="success"
              outlined
              @click="syncStoreName()"
            >
              Sincronizar razão social
            </v-btn>
          </div>
          <div>
            <user-store-closing-modal />
            <user-store-list
              v-model="clientId"
            />
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
      >
        <v-col cols="12">
          <v-row justify="start">
            <v-btn
              text
              @click="() => storeId = ''"
            >
              <v-icon>
                mdi-arrow-left
              </v-icon>
              Voltar
            </v-btn>
          </v-row>
          <v-row>
            <user-store-form
              ref="store"
              v-model="storeId"
            />
          </v-row>
        </v-col>
      </v-row>
    </fade-in-out>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import UserStoreList from 'App/users/components/tables/UserStoreList.vue';
import FadeInOut from 'Arch/components/transitions/FadeInOut.vue';
import UserStoreForm from 'App/users/components/forms/UserStoreForm.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import eventBus from '@/plugins/eventBus';
import UserStoreClosingModal from '../modals/UserStoreClosingModal.vue';
import StoreRequest from '../../services/StoreRequest';

export default {
  name: 'UserStoreContent',
  components: {
    FormGroup,
    UserStoreList,
    UserStoreForm,
    FadeInOut,
    UserStoreClosingModal,
  },
  mixins: [ServiceMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    storeId: '',
    loading: false,
    sgvClientId: '',
    requestClass: StoreRequest,
  }),
  computed: {
    clientId() {
      return this.value;
    },
    isDisabled() {
      return !this.sgvClientId;
    },
  },
  provide() {
    return {
      handleStoreId: this.handleStoreId,
      handleSyncStoreNameLoading: this.handleSyncStoreNameLoading,
      handleSgvId: this.handleSgvId,
    };
  },
  methods: {
    handleStoreId(id) {
      if (this.isNumber(id)) {
        this.storeId = id;
      }
    },
    handleSgvId(id) {
      if (this.isNumber(id)) {
        this.sgvClientId = id;
      }
    },
    isNumber(value) {
      return Number(value) >= 1;
    },
    handleSyncStoreNameLoading() {
      this.loading = !this.loading;
    },
    syncStoreName() {
      this.handleSyncStoreNameLoading();
      this.callService(
        this.requestClass.syncStoreName(
          this.sgvClientId,
        ),
        (_, isError) => {
          this.handleSyncStoreNameLoading();
          if (!isError) {
            eventBus.$emit(
              'store-closing-callback',
              true,
            );
          }
        },
        {
          successMessage: 'Sucesso ao sincronizar razão social!',
          errorMessage: 'Falha ao sincronizar razão social!',
        },
      );
    },
  },
};
</script>
